import {
  isHTMLElement
} from "./chunk-FKYCQ46C.mjs";

// src/contains.ts
function contains(parent, child) {
  if (!parent || !child)
    return false;
  if (!isHTMLElement(parent) || !isHTMLElement(child))
    return false;
  return parent === child || parent.contains(child);
}

export {
  contains
};
